import {DEVICE} from '@chekin/guestapp-ui-kit';
import ModalSheet from 'components/common/ModalSheet';
import styled from 'styled-components';

export const ContentInformationBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
  margin: 0 auto 72px;

  & div:first-child {
    position: relative;
    top: 2px;
  }

  @media (min-width: ${DEVICE.laptop}) {
    max-width: 320px;
    margin: 0 auto 48px;
  }

  path,
  circle {
    stroke: ${props => props.theme.colors.branding.fontSecondary};
  }
`;

export const SubTitleInformation = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: ${props => props.theme.colors.branding.fontSecondary};

  @media (min-width: ${DEVICE.laptop}) {
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const StyledIncompleteGuestsModal = styled(ModalSheet)`
  &-overlay {
    overflow: hidden;
  }

  &-content {
    @media (min-width: ${DEVICE.mobileL}) {
      max-width: 375px;
      padding-top: 60px;
      & .chekin-button_link {
        margin-bottom: 0;
      }
    }
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 220px;
`;
